import { actionTypes } from "./constants";
const initialState = {
  productModelList: [],
  logList:{
    list: [],
    total: 0,
  },
  logTypeList: [],
  qaContent:{
    keyword: '',
    title: '',
    propValue: '',
  },
  contacts:{
    keyword: '',
    title: '',
    propValue: '',
  },
  settingList:{
    list: [],
    total: 0,
  },
  logoFile: null,
  authSettingList: {
    list: [],
    total: 0,
  },
  modelList: [],
  publicFileList: {
    rows: [],
    count: 0,
  },
  systemVersionList: {
    rows: [],
    count: 0,
  },
};

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_PRODUCT_MODEL_LIST:
      return {
        ...state, productModelList: action.data,
      };
    case actionTypes.SET_OPERATION_LOG_LIST:
      return {
        ...state, logList: action.data,
      };
    case actionTypes.SET_OPERATION_LOG_TYPE_LIST:
      return {
        ...state, logTypeList: action.data,
      };
    case actionTypes.SET_QA_CONTENT:
      return {
        ...state, qaContent: action.data,
      };
    case actionTypes.SET_CONTACT_CONTENT:
      return {
        ...state, contacts: action.data,
      };
    case actionTypes.SET_SETTING_LIST:
      return {
        ...state, settingList: action.data,
      };
    case actionTypes.SET_LOGO_FILE:
      return {
        ...state, logoFile: action.data,
      };
    case actionTypes.SET_SETTING_AUTH_LIST:
      return {
        ...state, authSettingList: action.data,
      };
    case actionTypes.SET_MODEL_LIST:
      return {
        ...state, modelList: action.data,
      };
    case actionTypes.SET_PUBLIC_FILE_LIST:
      return {
        ...state, publicFileList: action.data,
      };
    case actionTypes.SET_SYSTEM_VERSION_LIST:
      return {
        ...state, systemVersionList: action.data,
      };
    default:
      return state;
  }
};